import { render, staticRenderFns } from "./VFooter.vue?vue&type=template&id=64da572c&scoped=true"
import script from "./VFooter.vue?vue&type=script&lang=ts"
export * from "./VFooter.vue?vue&type=script&lang=ts"
import style0 from "./VFooter.vue?vue&type=style&index=0&id=64da572c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da572c",
  null
  
)

export default component.exports